export const discount = {
  discountType: {
    campaign: "キャンペーン",
    loss: "損金",
  },
};
